/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Argon Dashboard 2 MUI base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";

// Argon Dashboard 2 MUI helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { background } = colors;
const { borderRadius } = borders;

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(256),
      whiteSpace: "nowrap",
      border: "none",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    },

    paper: {
      width: pxToRem(256),
      backgroundColor: background.dark,
      height: '100vh', // Make it full height
      margin: '0', // Remove floating/margin
      borderRadius: 0, // Remove border radius
      border: 'none',
      boxShadow: 'none', // Remove shadow for a flat look
      "&::-webkit-scrollbar": {
        display: "none"
      },
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
